import { render, staticRenderFns } from "./objectsLamp___.vue?vue&type=template&id=7c16746d&"
import script from "./objectsLamp___.vue?vue&type=script&lang=js&"
export * from "./objectsLamp___.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports